export class UpPulumiStacksResponse {
    'jobIds';
    'failedPulumiConfigIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobIds",
            "baseName": "jobIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "failedPulumiConfigIds",
            "baseName": "failedPulumiConfigIds",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return UpPulumiStacksResponse.attributeTypeMap;
    }
    constructor() {
    }
}
